export default __webpack_public_path__ + "static/media/piece2.b0c40c48.webp";